'use client'
import { noto_sans } from '@/globalConstants'
import { Prarthana } from '@/globalTypes'
import React, { useRef, useState } from 'react'
import AudioPlayer from '../AudioPlayer'


const PrarthanaForFestival = ({ prarthanas, festivalName }: { prarthanas: Prarthana[], festivalName: string }) => {
    const [audioCurrentlyPlaying, setAudioCurrentlyPlaying] = useState<Prarthana>(
        {
            "id": "",
            "title": "",
            "audio_url": "",
            "hls_audio_url": "",
            "image_url": "",
            "banner_image_url": "",
            "duration": "",
            "is_audio_available": true,
            "ui_info": {
                "image_url": "",
                "banner_image_url": ""
            }
        }
    );
    const currentAudioTagRef = useRef<{ audioTag: any, setIsPlaying: any }>({
        audioTag: undefined,
        setIsPlaying: () => { },
    });
    const updateCurrentPrarthana = (audio: HTMLAudioElement, action: string, prarthanaDetails: Prarthana, setIsPlaying: any) => {
        if (audioCurrentlyPlaying.id === prarthanaDetails.id) {
            if (action === 'pause') {
                audio.pause();
                setIsPlaying(false);
            } else {
                currentAudioTagRef.current.audioTag.play();
                currentAudioTagRef.current.setIsPlaying(true);
            }
        } else {
            if (currentAudioTagRef.current.audioTag) {
                currentAudioTagRef.current.audioTag.pause();
                currentAudioTagRef.current.setIsPlaying(false);

            }
            currentAudioTagRef.current = { audioTag: audio, setIsPlaying: setIsPlaying };
            setAudioCurrentlyPlaying(prarthanaDetails);
            audio.play();
            setIsPlaying(true);
        }

    }

    return (
        <div className={`panchanga__details__karana p-4 bg-white grid gap-[1rem] rounded-[8px] border-[1px] border-[#E5E0DF]`}>
            <div className='details__karana__header text-[1.25rem] font-[600] border-b-2 border-[#E5E0DF] text-[#1D4749] '>
                PRARTHANA FOR {festivalName.toUpperCase()}
            </div>
            <div className='details__karana__description grid gap-[1rem] sm:grid-cols-2  lg:gap-[3rem]'>
                {

                    Array.from(prarthanas).map((prarthana: Prarthana, index: number) => {
                        const title = `${index + 1}. ${prarthana.title}`;
                        return <div key={prarthana.id}>
                            <div className='grid gap-[14px] '>
                                <AudioPlayer src={prarthana.audio_url} updateCurrentPrarthana={updateCurrentPrarthana} prarthanaDetails={prarthana} type="panchanga" title={title} />

                            </div>
                        </div>

                    })
                }

            </div>
        </div>

    )
}

export default PrarthanaForFestival
